import utils from "@/utilities/Utils";
import { TriState } from "@/model/Enums";

export class UserSearchParameters {
    pageNumber: number = 1;
    id: string = utils.emptyGuidValue;
    roleID: number = 0;
    searchText: string = "";
    isDeleted: TriState = TriState.UseDefault;
}